import { de_GetSimulationCommand, se_GetSimulationCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
export class GetSimulationCommand extends $Command.classBuilder()
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
    ];
})
    .s("SimulationService", "GetSimulation", {})
    .n("SimulationServiceClient", "GetSimulationCommand")
    .f(void 0, void 0)
    .ser(se_GetSimulationCommand)
    .de(de_GetSimulationCommand)
    .build() {
}
